// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "copilot" + "." + "6b998cb7" + ".chunk.css";
};